exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-wrapper[data-v-bb31b428] {\n  width: 100%;\n}", ""]);

// exports
